
        var result = require("!!../../../../node_modules/css-loader/index.js!./role-editor.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/controls/role-editor.component.css
// module id = 675
// module chunks = 0